<template>
  <b-overlay :show="loaded" rounded="sm">
    <div class="role-view">
      <div class="bg-white mt-3 p-3 activity-type-create col-12">
        <div class="d-flex title-bar-block mb-2">
          <div class="icon-block me-4">
            <button v-b-tooltip.hover :title="$backLabel()" @click="cancel()" id="back-btn">
              <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
            </button>
          </div>
          <div class="text">
            <span class="me-2">{{ $translate("view_role") }} </span>
          </div>
        </div>
        <b-overlay :show="updating || generalDeleting" rounded="sm">
          <b-form id="role-form" class="form-sample" @submit.prevent="update()">
            <b-row>
              <b-col cols="12">
                <label for="input-name" class="mb-3"
                  ><strong
                    >{{ $nameLabel() }}<span class="red">*</span></strong
                  ></label
                >
                <b-form-input
                  type="text"
                  id="input-name"
                  v-model="model.name"
                  required
                  :placeholder="$translate('enter_name')"
                  trim
                ></b-form-input>
              </b-col>
              <b-col cols="12" md="2" class="mt-3 d-flex align-items-center">
                <div class="form-check me-3">
                  <label class="form-check-label">
                    <input
                      type="checkbox"
                      id="input-mobile_access"
                      v-model="model.mobile_access"
                      name="input-mobile_access"
                      :value="1"
                      :unchecked-value="0"
                    />
                    <i class="input-helper"></i>
                  </label>
                </div>
                <label
                  id="mobile_access-group"
                  for="input-mobile_access"
                  class="mb-1 ms-2"
                  ><strong> {{ $translate("mobile_access") }}</strong></label
                >
              </b-col>
              <b-col cols="12" md="2" class="mt-3 d-flex align-items-center">
                <div class="form-check me-3">
                  <label class="form-check-label">
                    <input
                      type="checkbox"
                      id="input-web_access"
                      v-model="model.web_access"
                      name="input-web_access"
                      :value="1"
                      :unchecked-value="0"
                    />
                    <i class="input-helper"></i>
                  </label>
                </div>
                <label
                  id="web_access-group"
                  for="input-web_access"
                  class="mb-1 ms-2"
                  ><strong> {{ $translate("web_access") }}</strong></label
                >
              </b-col>
              <b-col cols="12" class="my-3">
                <label class="form-control-label mb-3"
                  ><strong>{{ $translate("permissions") }}</strong></label
                >
                <permission-groups
                  v-model="model.permissions"
                ></permission-groups>
              </b-col>
              <b-col cols="12" class="my-3">
                <label class="form-control-label mb-3"
                  ><strong>{{
                    $translate("activity_type_permissions")
                  }}</strong></label
                >
                <activity-permission-groups
                  v-model="model.activity_permissions"
                ></activity-permission-groups>
              </b-col>
              <b-col cols="12" class="mt-3 d-flex gap-2 justify-content-center">
                <b-button id="save-btn"
                  v-if="hasPermissionUpdate"
                  @click="update()"
                  variant="info"
                  size="fw"
                  :disabled="updating ? true : false"
                  >{{
                    updating
                      ? $translate("saving_changes") + "..."
                      : $translate("save_changes")
                  }}</b-button
                >
                <b-button id="delete-btn"
                  v-if="hasPermissionDelete"
                  @click="deleteRole()"
                  size="fw"
                  variant="delete-button"
                >
                  {{ $translate("delete_role") }}
                </b-button>
                <b-button id="cancel-btn"
                  :disabled="updating"
                  variant="info"
                  size="fw"
                  @click="cancel()"
                >
                  {{ $cancelLabel() }}
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-overlay>
      </div>
    </div>
  </b-overlay>
</template>
<script>
//import Multiselect from 'vue-multiselect'
import axios from 'axios'
import ActivityPermissionGroups from "@/components/ActivityPermissionGroups";
import PermissionGroups from "@/components/PermissionGroups";
import popupMixins from "@/mixins/popupMixins";
import permissionsMixins from "@/mixins/permissionsMixins";
import utilityMixins from "@/mixins/utilityMixins";

export default {
  name: "roles-view",
  mixins: [popupMixins, utilityMixins, permissionsMixins],
  components: { PermissionGroups, ActivityPermissionGroups },
  data() {
    return {
      model: {
        id: 0,
        name: "",
        web_access: false,
        mobile_access: true,
        permissions: [],
        activity_permissions: [],
      },
      loaded: true,
      updating: false,
    };
  },
  computed: {
    componentName() {
      return this.$translate("role");
    },

    user_permissions() {
      return this.$store.getters.user_permissions;
    },
    role() {
      return this.$store.state.roles.item || {};
    },
    activityRole() {
      return this.$store.state.activityTypeRoles.item || {};
    },

    combinedRoles() {
      console.log('this is main role',this.role);
      console.log('this is activity role',this.activityRole);
      return {
        mainRole: this.role,
        activityRole: this.activityRole,
      };
    },
  },
  watch: {
    combinedRoles: {
      handler: function (val) {
        this.loaded = false;
        console.log("role changed", val);

        const { mainRole, activityRole } = val;

        const model = { ...mainRole };

        model.permissions = model.permissions.map((x) => x.permission);
        model.activity_permissions = (
          activityRole.activity_permissions || []
        ).map((x) => x.activity_permission);

        console.log('this is model',model.activity_permissions);
        this.model = model;
      },
      deep: true,
    },
  },
  methods: {
    cancel() {
      this.$router.push("/ams/roles");
    },
    async update() {
      try {
        this.updating = true;
        const valid = await this.$validator.validate();
        if (!valid) {
          throw new Error("Not Valid");
        }

        const newModel = { ...this.model };

        //change the format of request body for activity type
        newModel.activity_permissions = newModel.activity_permissions.map(item => {
         
        if (item.type_id !== undefined) {
          let { type_id, slug, name } = item;
          console.log('this is type_id',type_id)
        return { id: type_id, slug, name };
        }
        return item;
      });
        console.log("newModel:", newModel);
        const resp = await this.$store.dispatch("roles/update", newModel);

        const {
            token,
            user,
            expires,
            isAdmin,
            permissions: rolePermissions,
            activity_type_permissions,
            customers: user_customers,
          } = resp.data.success.data.original.success.data;

          console.log('role--', {
            token,
            user,
            expires,
            isAdmin,
            rolePermissions,
            activity_type_permissions,
            user_customers,
          })

          axios.defaults.user = user;
          axios.defaults.rolePermissions = rolePermissions;
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          const storeToken = JSON.stringify({
            token,
            user,
            expires,
            isAdmin,
            activity_type_permissions,
            rolePermissions,
            user_customers,
          });

          this.$secureStorage.setItem("accessToken", storeToken);

          // localStorage.setItem(
          //     'rolePermissions',
          //     JSON.stringify(rolePermissions)
          // )
          // localStorage.setItem('accessUser', JSON.stringify(user))
          //Define The Users Access Permissions
          // --------------------------------------------------

          this.$store.commit("AUTHENTICATE", {
            token,
            user,
            activity_type_permissions,
            rolePermissions,
            expires,
            isAdmin,
            user_customers,
          });

        this.genericToast(
          this.componentName,
          this.$translate("updated"),
          "success",
          `${this.$translate("role")} ${this.$translate("update_alert")}`
        );
      } catch (error) {
        this.genericToast(
          this.componentName,
          this.$translate("error"),
          "danger",
          `${error.message}`
        );
      } finally {
        this.updating = false;
      }

      // this.doToast('Role Updated', 'success')
    },

    async deleteRole() {
      const model = { ...this.model };
      const routes = {
        baseRoute: "/roles",
        deleteRoute: "roles/delete",
      };
      const notificationFields = {
        type: this.$translate("role"),
        errorMsg: this.$translate("role_assign_alert"),
      };

      await this.deleteItem(notificationFields, model, routes);
    },
  },
  mounted() {
    this.$store.dispatch("permissions/all");
    this.$store.dispatch("permissions/allActivityTypePermission");

    this.$store.dispatch("roles/fetchById", this.$route.params.id);
    this.$store.dispatch("activityTypeRoles/fetchById", this.$route.params.id);
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
